import React from "react";
import Img from "./img";
import shapeImage from "@/images/shape/service-color-shape.png";

const ServiceInfo = () => {
  return (
    <div className="service_style_2_area text-center section_padding">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="justify-content-center d-flex">
              <p className="col-md-10 ">
                  Per ambienti, immobili, sedi di istituzioni pubbliche o private, privati.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceInfo;
